import script from "./GalleryRoute.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryRoute.vue?vue&type=script&setup=true&lang=js"

import "./GalleryRoute.vue?vue&type=style&index=0&id=69525cae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69525cae"]])

export default __exports__